import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-medecin-cms',
  templateUrl: './medecin-cms.component.html',
  styleUrls: ['./medecin-cms.component.scss']
})
export class MedecinCmsComponent implements OnInit {
  mode_page: number = 1;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  medecins(){
    this.router.navigate(['medecins']);    
  }

  index_(){
    this.router.navigate(['index']); 
    
  }


  pagination(inte:number){
    if(inte==1){
      this.mode_page=1;
    }else  if(inte==2){
      this.mode_page=2;
    }else{
      this.mode_page=3;
    }
   
  }

}
